// This file is generated by pnpm icons:generate. Do not edit.

import {CodeLines_Stroke2_Corner2_Rounded as CanonicalCodeLines_Stroke2_Corner2_Rounded} from './Code'

/** @deprecated Import CodeLines_Stroke2_Corner2_Rounded from `#/components/icons/Code` instead. */
export const CodeLines_Stroke2_Corner2_Rounded =
  CanonicalCodeLines_Stroke2_Corner2_Rounded
